<template>
  <div class="box">
    <div class="columns is-multiline">
      <div class="column is-4 is-12-mobile">
        <BField
          label="Nombre de Banco Ordenante"
        >
          <AppSelectField
            id="bankName"
            name="bankName"
            placeholder="Selecciona el banco"
            :options="bankCatalog"
            :value="bankName"
            @input="onChangePaymentBank($event)"
            @change="onChangePaymentBank($event)"
          />
        </BField>
      </div>
      <div class="column is-4 is-12-mobile">
        <BField
          label="Cuenta Ordenante"
        >
          <BInput
            id="issuingAccount"
            name="issuingAccount"
            :value="issuingAccount"
            maxlength="50"
            :pattern="accountPattern"
            type="string"
            min="0"
            placeholder="1234567890"
            @input="onChangePayment($event, 'issuingAccount')"
            @change="onChangePayment($event, 'issuingAccount')"
          />
        </BField>
      </div>

      <div class="column is-4 is-12-mobile">
        <BField
          label="RFC Emisor de Cuenta Ordenante"
        >
          <BInput
            id="issuingRfc"
            name="issuingRfc"
            :value="issuingRfc"
            validation-message="Rfc de la entidad bancaria"
            maxlength="12"
            type="string"
            :pattern="rfcPattern"
            placeholder="XAXX010101000"
            @input="onChangePayment($event, 'issuingRfc')"
            @change="onChangePayment($event, 'issuingRfc')"
          />
        </BField>
      </div>

      <div class="column is-4 is-12-mobile">
        <BField
          label="Número de operación (Referencia)"
        >
          <BInput
            id="operationNumber"
            :value="operationNumber"
            maxlength="100"
            :pattern="operationPattern"
            type="string"
            placeholder="12345ABC"
            @input="onChangePayment($event, 'operationNumber')"
            @change="onChangePayment($event, 'operationNumber')"
          />
        </BField>
      </div>

      <div class="column is-4 is-12-mobile">
        <BField
          label="Cuenta Beneficiario"
        >
          <BInput
            name="receiverAccount"
            :value="receiverAccount"
            maxlength="50"
            :pattern="accountPattern"
            type="string"
            step="0.01"
            min="0"
            placeholder="1234567890"
            @input="onChangePayment($event, 'receiverAccount')"
            @change="onChangePayment($event, 'receiverAccount')"
          />
        </BField>
      </div>

      <div class="column is-4 is-12-mobile">
        <BField
          label="RFC Emisor de Cuenta Beneficiario"
        >
          <BInput
            id="receiverRfc"
            name="receiverRfc"
            :value="receiverRfc"
            maxlength="12"
            type="string"
            :pattern="rfcPattern"
            placeholder="XAXX010101000"
            @input="onChangePayment($event, 'receiverRfc')"
            @change="onChangePayment($event, 'receiverRfc')"
          />
        </BField>
      </div>
    </div>
  </div>
</template>

<script>
import merge from 'lodash/merge';
import {
  mapState,
  mapMutations,
  mapActions,
} from 'vuex';

import {
  bank,
} from '@machete/common-catalogs';

const arrayToOptions = array => array.map(
  ({ key, value }) => ({
    value,
    label: `${key} - ${value}`,
  }),
);

export default {
  name: 'AdvancedValues',
  components: {
    AppSelectField: () => import(/* webpackChunkName: "app-select-field" */ '@/components/AppSelectField.vue'),
  },
  data() {
    return {
      rfcPattern: '^([A-Z&Ñ]{3}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A])|XEXX010101000$',
      accountPattern: '^[0-9]{10,50}',
      operationPattern: '^[0-9A-Z&Ña-z&ñ]{1,100}',
      bankCatalog: arrayToOptions(bank),
    };
  },

  computed: merge(
    mapState({
      operationNumber: state => state.invoice.complement.payments[0].operationNumber,
      issuingRfc: state => state.invoice.complement.payments[0].issuingRfc,
      bankName: state => state.invoice.complement.payments[0].bankName,
      issuingAccount: state => state.invoice.complement.payments[0].issuingAccount,
      receiverRfc: state => state.invoice.complement.payments[0].receiverRfc,
      receiverAccount: state => state.invoice.complement.payments[0].receiverAccount,
    }),
    {
      paymentTypeSelectedValue() {
        return this.paymentTypeCatalog.find(curr => curr.value === this.wayPay);
      },
      currencySelectedValue() {
        return this.currencyCatalog.find(curr => curr.value === this.paymentCurrency);
      },
    },
  ),
  methods: merge(
    mapMutations({
      setPaymentValue: 'invoice/updatePayment',
    }),
    mapActions({ getCatalog: 'ui/getCatalog' }),
    {
      onChangePayment(value, name) {
        this.setPaymentValue({ accessor: name, value });
      },
      onChangePaymentBank(event) {
        const { name: accessor, value } = event.target;
        this.setPaymentValue({ accessor, value });
      },
    },
  ),
};
</script>

<style scoped>
.title {
  margin-bottom: 1rem;
}
</style>
